import { render, staticRenderFns } from "./NutritionalIndicator.vue?vue&type=template&id=6ef328c3&scoped=true"
import script from "./NutritionalIndicator.vue?vue&type=script&lang=js"
export * from "./NutritionalIndicator.vue?vue&type=script&lang=js"
import style0 from "./NutritionalIndicator.vue?vue&type=style&index=0&id=6ef328c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef328c3",
  null
  
)

export default component.exports